export { Theme as default, domainTheme, select, theme } from '@lendi/ui';
